import Model from './Model'

export default class Practitioner extends Model {
  resource() {
    return 'practitioners'
  }
}
